export enum TOASTER_TYPES {
  SUCCESS = 0,
  FAILURE = 1,
}
